import * as Sentry from '@sentry/react';

interface ErrorFallbackProps {
  error: Error;
  componentStack?: string | null;
  eventId?: string | null;
  resetError?(): void;
}

export const ErrorFallback = ({ error, componentStack, resetError }: ErrorFallbackProps) => {
  return (
    <div className="min-h-[200px] flex items-center justify-center bg-background">
      <div className="max-w-md w-full p-6 text-center">
        <h2 className="text-2xl font-bold text-destructive mb-4">Something went wrong</h2>
        <p className="text-muted-foreground mb-4">We've been notified and will fix this as soon as possible.</p>
        <button
          onClick={() => {
            Sentry.addBreadcrumb({
              category: 'ui',
              message: 'User clicked retry after error',
              level: 'info'
            });
            if (resetError) {
              resetError();
            } else {
              window.location.reload();
            }
          }}
          className="bg-primary text-primary-foreground px-4 py-2 rounded hover:bg-primary/90"
        >
          {resetError ? 'Try Again' : 'Refresh Page'}
        </button>
        {import.meta.env.MODE !== 'production' && (
          <pre className="mt-4 p-4 bg-muted text-left overflow-auto rounded">
            <code>{error.message}</code>
            {componentStack && (
              <code className="block mt-2 text-xs">{componentStack}</code>
            )}
          </pre>
        )}
      </div>
    </div>
  );
}; 